import { engineComponent } from "neo-common";
import { ComponentTypes } from "../Components/ComponentTypes";
import { HtmlButtonElement } from "../HTMLComponents/Elements/HtmlButtonElement";
import { PlayList } from "../Components/Sounds/PlayList";
import { DataManager } from "../Managers/DataManager";
import { HtmlController } from "../HTMLComponents/HtmlController";

@engineComponent(ComponentTypes.HtmlElement)
export class HtmlSchemaSelectButtonElement extends HtmlButtonElement {
    public static readonly SchemaSelected: "eventSchemaSelected";

    private selectIndex: number;
    private touchStartX: number;
    private touchStartY: number;

    constructor(index: number) {
        super();
        this.touchStartX = 0;
        this.touchStartY = 0;
        this.selectIndex = index;
    }

    registerEvents(): void {
        if (this.action != null || this.uiaction != null) {
            this.instance.addEventListener("touchstart", this.onClick.bind(this));
            this.instance.addEventListener("touchend", this.onClick.bind(this));
            this.instance.addEventListener("click", this.onClick.bind(this));
            if (this.action != null) {
                this.instance.classList.add(HtmlController.DisabledClass);
            }
        }
    }

    onClick(e: any): void {
        let diffX = 0;
        let diffY = 0;
        if (e.type == "touchstart") {
            this.touchStartX = e.touches[0].pageX;
            this.touchStartY = e.touches[0].pageY;
        }
        if (e.type == "touchend") {
            let currentX = e.changedTouches[0].pageX;
            let currentY = e.changedTouches[0].pageY;
            diffX = Math.abs(this.touchStartX - currentX);
            diffY = Math.abs(this.touchStartY - currentY);
        }
        if (this.selectIndex != null) {
            DataManager.SchemaSelected = this.selectIndex;
        }
        if (window["CHANNEL"] == "mobile") {
            if (e.type == "touchend" && diffX <= 30 && diffY <= 30) super.onClick(e);
        } else {
            super.onClick(e);
        }
    }

    // onClick(e: any): void {
    //     if(this.selectIndex != null) {
    //         DataManager.SchemaSelected = this.selectIndex;
    //     }
    //     super.onClick(e);
    // }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/HtmlSchemaSelectButtonElement.ts
 **/